import { customChannels } from 'dashboard/channels/customChannels';
import Internal from 'custom/app/javascript/dashboard/channels/Internal.vue';

customChannels.registerFormComponent('internal', Internal);

customChannels.registerListEntry({
  key: 'internal',
  titleKey: 'INBOX_MGMT.ADD.AUTH.CHANNEL.INTERNAL.TITLE',
  descriptionKey: 'INBOX_MGMT.ADD.AUTH.CHANNEL.INTERNAL.DESCRIPTION',
  icon: 'i-ri-team-fill',
});

// Replaces the OSS "Mine / Unassigned / All" assignee tabs with internal-chat
// tabs (Conversations / Groups / All) when the active inbox is Channel::Internal.
// `ChatList.vue` calls `customChannels.listTabs(channelType, { t, getters })`;
// the filtering itself is done by `ChatList.vue` using `additional_attributes.internal.kind`.
customChannels.registerListTabs('Channel::Internal', ({ t }) => [
  { key: 'all', name: t('INTERNAL_CHAT.TABS.ALL') },
  { key: 'dm', name: t('INTERNAL_CHAT.TABS.DM') },
  { key: 'room', name: t('INTERNAL_CHAT.TABS.ROOM') },
]);

customChannels.registerSettingsTab('Channel::Internal', {
  key: 'groups',
  label: 'INTERNAL_CHAT.GROUPS.TAB_LABEL',
  component: () =>
    import(
      'custom/app/javascript/dashboard/routes/dashboard/settings/inbox/internal-groups/InternalGroupsTab.vue'
    ),
});

customChannels.registerSettingsTab('Channel::Internal', {
  key: 'auditors',
  label: 'INTERNAL_CHAT.AUDITORS.TAB_LABEL',
  component: () =>
    import(
      'custom/app/javascript/dashboard/routes/dashboard/settings/inbox/internal-auditors/InternalAuditorsTab.vue'
    ),
});
